/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Lifetime_2Inputs */

const cs_projects_lifetime_2 = /** @type {(inputs: Projects_Lifetime_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 měsíce`)
};

const en_projects_lifetime_2 = /** @type {(inputs: Projects_Lifetime_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 months`)
};

/**
* | output |
* | --- |
* | "3 months" |
*
* @param {Projects_Lifetime_2Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_lifetime_2 = /** @type {((inputs?: Projects_Lifetime_2Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Lifetime_2Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_lifetime_2(inputs)
	return cs_projects_lifetime_2(inputs)
});